import { useEffect } from 'react';
import { useParams } from 'react-router';
import { EoeEmailVerification } from '../../../../components/EoeEmailVerification/EoeEmailVerification.js';
import { useAuth } from '../../AuthProvider';
import type { Token } from '../../../../common/constants/pathInterfaces.js';

export const EoeEmailVerificationPath = () => {
  const { verifyEmail } = useAuth();
  const { token = '' } = useParams<Token>();
  useEffect(() => {
    verifyEmail(token);
  }, [verifyEmail, token]);

  return <EoeEmailVerification />;
};
